import { Article, DocsHeader, DocsHeading, DocsIntro, Section, SectionHeader, Image } from "../extra/Components";

import faltet from '../assets/3 faltet/1 faltet-small.jpg';
import faltet_small from '../assets/3 faltet/1 faltet.JPG';

import bana from '../assets/3 faltet/2 0 bana-small.jpg';
import bana_small from '../assets/3 faltet/2 0 bana-small.jpg';

import asfaltbanan from '../assets/3 faltet/2 1 asfaltsbana-small.jpg';
import asfaltbanan_small from '../assets/3 faltet/2 1 asfaltsbana-small.jpg';

import grasBanor from '../assets/3 faltet/2 2 gräsbanor-small.jpg';
import grasBanor_small from '../assets/3 faltet/2 2 gräsbanor-small.jpg';

import flygplan from '../assets/3 faltet/3 flygplan-small.jpg';
import flygplan_small from '../assets/3 faltet/3 flygplan-small.jpg';

import inuti from '../assets/3 faltet/3 flygplan inuti-small.jpg';
import inuti_small from '../assets/3 faltet/3 flygplan inuti-small.jpg';

import flygspannen from '../assets/3 faltet/3 3 flygspännen-small.jpg';
import flygspannan_small from '../assets/3 faltet/3 3 flygspännen-small.jpg';

import ilastning from '../assets/3 faltet/8 ilastning-small.jpg';
import ilastning_small from '../assets/3 faltet/8 ilastning-small.jpg';

import karta from '../assets/3 faltet/4 hangar karta label-small.jpg';
import karta_small from '../assets/3 faltet/4 hangar karta label-small.jpg';


import klubbstuga from '../assets/3 faltet/6 klubbstuga2 label-small.jpg';
import klubbstuga_small from '../assets/3 faltet/6 klubbstuga2 label-small.jpg';

import klubbstuga3 from '../assets/3 faltet/6 klubbstuga3-small.jpg';
import klubbstuga3_small from '../assets/3 faltet/6 klubbstuga3-small.jpg';


import landning from '../assets/3 faltet/7 landning label-small.jpg';
import landning_small from '../assets/3 faltet/7 landning label-small.jpg';


import strut from '../assets/3 faltet/vindriktning/1 strut-small.jpg';
import strut_small from '../assets/3 faltet/vindriktning/1 strut-small.jpg';


import hangar from '../assets/3 faltet/4 hangar.JPG';
import hangar_small from '../assets/3 faltet/4 hangar-small.jpg';

import vindT from '../assets/3 faltet/vindriktning/2 vindT-small.jpg';
import vindT_small from '../assets/3 faltet/vindriktning/2 vindT-small.jpg';

import platser from '../assets/3 faltet/vindriktning/3 platser-small.jpg';
import platser_small from '../assets/3 faltet/vindriktning/3 platser-small.jpg';

import texempel from '../assets/3 faltet/vindriktning/t/T exempel.jpg';
import texempel_small from '../assets/3 faltet/vindriktning/t/T exempel-small.jpg'

import hl from '../assets/3 faltet/2 hl/1 hl-small.jpg';
import hl_small from '../assets/3 faltet/2 hl/1 hl-small.jpg';

import hlT from '../assets/3 faltet/10 HL T.jpg'
import hlT_small from '../assets/3 faltet/10 HL T-small.jpg'

import hlTOvanifran from '../assets/3 faltet/9 hl-t ovanifran.jpg'
import hlTOvanifran_small from '../assets/3 faltet/9 hl-t ovanifran-small.jpg'

import { Question, Questionary } from "../extra/Quiz";
import { faPlaneDeparture } from "@fortawesome/free-solid-svg-icons";


const faltetQuiz = [
    Question.oneQ("Hur går jag förbi ett flygplan?", "Bakom", ["Framför"]),
    Question.oneQ("Vad gör jag om jag råkat landa på gräslandningsbanan?", "Springer av den", ["Skyndar mig att samla ihop mina saker", "Tar det som vanligt", "Tittar efter flygplan"]),
    Question.oneQ("Vad gör jag om jag råkat landa på asfaltsbanan?", "Springer av den", ["Skyndar mig att samla ihop mina saker", "Tar det som vanligt", "Tittar efter flygplan"]),
    Question.oneQ("Får jag landa på C-fältet som elev?", "Nej", ["Ja", "Om jag ber om lov först"]),
    Question.oneQ("Upp till vilken höjd ska lastsäkringsbältet vara kopplat?", "300m", ["500m", "100m", "700m"]),
    Question.oneQ("Vilken fallskärm ska man använda vid nödhopp på 450m?", "Reservfallskärmen", ["Huvudfallskärmen", "Ingen, sitt kvar"]),
    Question.oneQ("Vilken fallskärm ska man använda vid nödhopp på 150m?", "Ingen, sitt kvar", ["Huvudfallskärmen", "Reservfallskärmen"]),
    Question.oneQ("Vilken fallskärm ska man använda vid nödhopp på 2000m?", "Huvudfallskärmen", ["Reservfallskärmen", "Ingen, sitt kvar"]),
    Question.oneQ("Vem har företräde på en taxibana?", "Flygplan", ["Fotgängare", "Den till höger", "Den längst fram"]),
    Question.oneQ("När får jag flyga min fallskärm över gräslandningsbanan", "Ovanför 300 m", ["Över 100 m", "När jag behöver", "Aldrig, flyg runt"]),
    Question.oneQ("Var brukar vi kliva ombord på flygplanet?", "Bredvid tankstationen", ["Framför hangaren", "På landningsbanan", "På taxibanan"]),
    Question.oneQ("Vem säger till dig om du landar där du inte får?", "Hoppledaren", ["Polisen"])
];




const faltetHeader = <DocsHeader>
    <DocsHeading note="Updaterad: 2022-07-12">Flygfältet</DocsHeading>
    <DocsIntro>
        <Image image={faltet} imageSmall={faltet_small} alt="Flygfältet" />

        <p>Vi hoppar på flygfältet i Eslöv. Det är här vår hangar med flygplanet finns. Klubbstugan
            där kurser genomförs är också där.</p>
        <p>Här finns även landningsområden, startbanor taxibanor med mera.</p>
    </DocsIntro>
</DocsHeader>;
const faltetBanor = <Section id="banor" name="Banor">
    <SectionHeader>Banor</SectionHeader>
    <Image image={bana} imageSmall={bana_small} alt="Landningsbanor" />

    <p>Landningsbanan är det riktmärke som är lättast att få syn på uppifrån. Flygplan använder de
        för att starta och landa. På landningsbanor har flygplan ALLTID förtur. Utöver asfaltbanan
        finns två stycken gräslandningsbanor. En parallellt med asfalten och en i en annan riktning.
        Flygplan använder gräsbanorna också, samma regler gäller på de. Utöver landningsbanorna
        finns taxibanor som flygplan kör på. Även där har flygplanen företräde och går man förbi ett
        flygplan går man bakom. Korsar man en landningsbana spanar man först att det är fritt och
        sedan springer över. Skulle man råka landa på en landningsbana så springer man av den
        omedelbart.</p>
    <p>Vill man korsa landningsbanan i luften när man flyger sin fallskärm ska man göra det högre än
        300 meter.</p>
    <h3>Asfaltsbanan</h3>

    <Image image={asfaltbanan} imageSmall={asfaltbanan_small} alt="Asfaltsbanan" />

    <p>Här lyfter flygplan oftast. Används regelbundet för landningar</p>
    <h3>Gräsbanor</h3>

    <Image image={grasBanor} imageSmall={grasBanor_small} alt="Gräsbanor" />

    <p>Gräset parallellt med asfalten, så kallat stråket, används regelbundet av flygplan. Den
        kortare banan används sällan men ska likväl respekteras.</p>
</Section>;

const faltetFlyInfo = <>
    <SectionHeader>I och runtFlygplan</SectionHeader>
    <Image image={flygplan} imageSmall={flygplan_small} alt="Flygplanet" />

    <p>Vi hoppar från en Cessna 208B, Grand Caravan. Det är ett rymligt flygplan som kan ta 19
        hoppare till höjd samtidigt. Fallskärmshoppare räknas som last, inte passagerare, och
        bekvämligheterna är därefter. Turen till 3000 meter tar ungefär 25 minuter. Två minuter
        innan det är dags att hoppa av tänder piloten en röd lampa längst bak i flygplanet. Då gör
        man en sista koll att all sin utrustning är på plats. Gul lamp så öppnas dörren och första
        gruppen kan börja "spotta", mer om det senare. Grön lampa så börjar folk hoppa av. Mellan
        grupperna ska det vara en liten väntan. Ca 7-10 sekunder beroende på vindar.</p>
    <p>Flygplan har dålig sikt framåt och har svårt att stanna plötsligt. Därav går vi aldrig
        framför flygplan som är igång eller en pilot sitter i. Är vi tveksamma går vi bakom.</p>

    <Image image={inuti} imageSmall={inuti_small} alt="I planet" />

    <p>De första 300 meterna sitter vi fastspända med lastsäkringsbälten. När man sitter på bänken
        så finns bälten åt ytterväggen. De har en skothake man spänner fast sig med. Antingen direkt
        i riggen eller genom benremmen och fast i sitt eget band. Det är också hjälmkrav för alla
        utan kamerahjälmar dessa första 300m. Det är rekommenderat att använda hjälm hela flygturen.
    </p>
    <p>Inuti finns två bänkar vi sitter på. Ut mot väggarna är lastsäkringsbälten som man säkrar sig
        själv med för start.</p>

    <Image image={flygspannen} imageSmall={flygspannan_small} alt="Skothake i planet" />

    <p>För att stänga den trycker man bara ihop den. För att öppna den drar man i det röda bandet.</p>
</>

const faltetNodhopp = <>
    <h2>Nödhopp:</h2>
    <p>Skulle ett flygplan haverera på vägen till uthoppshöjd har vi fallskärmar vi kan använda.
        Beroende på vilken höjd flygplanet är på använder vi olika fallskärmar.</p>
    <p>Nödhopp beordras av piloten genom att den ropar ut antingen "Nödhopp!" eller "Emergency jump!"</p>
    <table className="table table-bordered">
        <tbody>
            <tr>
                <th className="theme-bg-light">över 700 m</th>
                <td>Vanligt hopp</td>
            </tr>
            <tr>
                <th className="theme-bg-light">300-700 m</th>
                <td>Hoppa av och dra reserv</td>
            </tr>
            <tr>
                <th className="theme-bg-light">under 300 m</th>
                <td>Landar med flygplanet. Lastsäkringsbälte fastsatt</td>
            </tr>
        </tbody>
    </table>
    <p>Skulle ett nödhopp inträffa under utbildningen innan vi lärt oss exitera stabilt använder vi med
         fördel reserven för alla höjder om inte instruktören säger något annat.</p>
</>;

const faltetIlastning = <>
    <h2>Ilastning</h2>

    <Image image={ilastning} imageSmall={ilastning_small} alt="Ilastning" />

    <p>Ilastning beskriver processen när man kliver ombord på flygplanet. Vanliga ilastningsplatsen
        är bredvid bränsletankarna bredvid änden utav landningsbanan. När flygplanet kör fram håller
        man sig ur vägen. Någon erfaren rullar fram stegen och öppnar dörren. Därefter kliver
        hopparna på i omvänd uthoppsordning. Elever följer sin instruktörs instruktion och kliver
        raskt ombord när det är sin tur. Man ska vara färdig för att hoppa av när man går ombord.
        Alla remmar spända och hjälm på. Spänner fast sig och kollar att all utrustning är på plats
        för att kunna hoppa av. Turen upp till uthoppshöjd tar ca 20 minuter.</p>
</>


const faltetFlygplanet = <Section id="flygplan" name="I och runt Flygplan">
    {faltetFlyInfo}
</Section>;

const faltetFlygplanetLong = <Section id="flygplan" name="I och runt Flygplan">
    {faltetFlyInfo}
    {faltetNodhopp}
    {faltetIlastning}
</Section>;

const faltetHangar = <Section id="hangar" name="Hangar">
    <SectionHeader>Hangar</SectionHeader>
    <Image image={karta} imageSmall={karta_small} alt="Hangar karta" />

    <p>Hangaren är därifrån hoppningen utgår. Hangaren är som namnet antyder även den hangar där
        flygplanet står när det inte är hoppning. Här har vi fallskärmar och utrustning. När
        flygplanet är ur hangaren har vi packmattor över golvet. På dessa packar vi våra fallskärmar
        och lämnar skor bredvid. I mitten finns en ramp för flygplanet. Till höger om den packar för
        det mesta tandem och packare. Till vänster är övriga. Även i hangaren är en disk som utgör
        manifest. Det är där man anmäler vilka lifter med flygplanet man vill vara med på. Under
        utbildningen kommer det göras utav eller i samråd med din instruktör. </p>

    <Image image={hangar} imageSmall={hangar_small} alt="Hangar" />
</Section>;
const faltetKlubbstuga = <Section id="klubbstuga" name="Klubbstuga">
    <SectionHeader>Klubbstuga</SectionHeader>
    <Image image={klubbstuga} imageSmall={klubbstuga_small} alt="Klubbstuga karta" />
    <Image image={klubbstuga3} imageSmall={klubbstuga3_small} alt="Klubbstuga" />

    <p>Klubbstugan har utbildningslokaler och sovutrymmen. Det är här kurser hålls och där kurser
        utgår från. Vill man övernatta på fältet så finns sängar här. Det finns inga lakan eller
        täcken. Det är sällan någon sover här i och med de flesta har ganska kort hem. Klubbfester
        brukar också vara här.</p>
</Section>;

const Faltet = ({ setSection, setArticle }) => (
    <Article id="faltet" icon={faPlaneDeparture} name="Flygfältet" setArticle={setArticle} setSection={setSection}>
        {faltetHeader}
        {faltetBanor}
        {faltetFlygplanetLong}

        {faltetHangar}
        {faltetKlubbstuga}
        <Section id="landningomrade" name="Landningsområde">
            <SectionHeader>Landningsområden</SectionHeader>
            <Image image={landning} imageSmall={landning_small} alt="Landningsområden" />

            <p>Våra landningsområden är uppdelade i ett generellt landningsområde för alla och en litet
                landningsområde framför hangaren för hoppare med minst C-cert. På andra sidan landningsbanan
                är det tillåtet att landa och rentav uppmuntras i vissa vindförhållanden. Det finns också
                flera områden såsom landningsbanor vi inte landar på. Ute på vårat landningsområde finns en
                stor cirkel klippt den tjänar bara som måltavla med gräs som klipps oftare än resten av
                landningsområdet</p>
        </Section>
        <Section id="vindriktning" name="Vindriktning">
            <SectionHeader>Vindriktning</SectionHeader>
            <Image image={strut} imageSmall={strut_small} alt="Vindstrut" />

            <p>När vi hänger i fallskärmen flyter vi med lufthavet och utan att se marken kan vi inte veta
                åt vilket håll det blåser. Även när man ser marken kan det vara klurigt och därför
                finns hjälpmedel på fältet.</p>
            <p>Ovan är bild på en vindstrut som ger både vindriktning och vindstyrka. Desto mindre det
                blåser desto svårare är det att se på struten vilket håll det blåser. Därför har vi också
                ett vind T</p>

            <Image image={vindT} imageSmall={vindT_small} alt="Vind T" />

            <p>Vind T-t får sitt namn från att det ser ut som ett T ovanifrån och vänder sig efter vinden.
                När man ser det och det är rättvänt som ett T så har man vinden i ansiktet. Dvs böjer man
                ner hatten på T till en pil så pekar den mot vindens ursprung. Vind Tt har fördelen att det
                är lika lätt att se vindriktning på oberoende av hur mycket det blåser. Det är framför allt
                vind Tt vi använder för att bestämma landningsriktning.</p>
            <h4>Vindhjälpmedlens positioner</h4>
            <Image image={platser} imageSmall={platser_small} alt="Vind Ts och vindstrut platser" />

            <p>Med vind pratar om man om "uppvind" för saker som ligger åt det hållet vinden kommer från
                relativt fältet och "nedvind" för saker som är dit vinden blåser.</p>
            <h4>Fler exempel på hur vind T set ut ovanifrån.</h4>
            <Image image={texempel} imageSmall={texempel_small} alt="Vind T ovanifrån" />

        </Section>
        <Section id="hl" name="HL">
            <SectionHeader>HL: Hoppledaren </SectionHeader>
            <Image image={hl} imageSmall={hl_small} alt="HL" />

            <p>Hoppledaren är den som ansvarar för att hoppningen bedrivs på ett säkert sätt. Hoppledaren
                har en väst det står hoppledare på. Det är en ideell tjänst som erfarna hoppare turas om att
                ha under säsongen. Hoppledaren har en radio och kommunicerar med piloten i flygplanet.</p>
            <p>Hoppledaren har rätt att hoppstoppa ("ground-a") hoppare som inte sköter sig. Har du frågar
                på
                var och när du ska någonstans kan man alltid fråga hoppledaren.</p>
        </Section>

        <Section id="hlt" name="Utlagt T">
            <SectionHeader>Utlagt T </SectionHeader>
            <p>En av HLs auktoriteter är att lägg ut ett T som styr över de vinddrivna riktmärkena.</p>
            <Image image={hlT} imageSmall={hlT_small} alt="HL T" />
            <p>Ett utlagt T används för att klargöra vilken landningsriktning som ska användas. Om vind T och
                utlagt T inte stämmer överens så är det det utlagda T-et som gäller på hangarsidan utav landningsbanan.</p>
            <Image image={hlTOvanifran} imageSmall={hlTOvanifran_small} alt="HL T ovanifrån" />
        </Section>

        <Section id="faltet-quiz" name="Quiz">
            <SectionHeader>Quiz, flygfältet</SectionHeader>
            <Questionary questions={faltetQuiz} />

        </Section>
    </Article>);

export { Faltet, faltetQuiz, faltetHeader, faltetBanor, faltetFlygplanet, faltetHangar, faltetKlubbstuga, faltetNodhopp, faltetIlastning };